export default {
    // c
    fleetList: {
        method: 'POST',
        url: "/admin/bill/check-bill/fleet-list",
        name: '所属车队列表'
    },

    // 物流列表导出
    waybillIndexStartTask: {
        method: 'POST',
        url: "/sortingCityAdmin/front-end/start-transport-task",
        name: '物流列表导出'
    },

    // 运单列表
    billList: {
        method: 'POST',
        url: "/sortingCityAdmin/front-end/back-transport-list",
        name: '运单列表'
    },


    // 详情
    billDetails: {
        method: 'POST',
        url: "/sortingCityAdmin/front-end/back-transport-details",
        name: '运单详情'
    },
    // 出库列表
    sellList: {
        method: 'GET',
        url: "/sortingCityAdmin/front-end/back-outbound-list",
        name: '出库列表'
    },
    // 出库详情
    sellDetail: {
        method: 'GET',
        url: "/sortingCityAdmin/front-end/back-outbound-detail",
        name: '出库列表详情'
    },

}
